module.exports = __webpack_public_path__ + "media/images/grey_cross_vector-7bb070d571cefdf6dee41853bad3e528.svg";